import React from 'react';
import { Marker, OverlayView } from '@react-google-maps/api';
import { Clusterer } from '@react-google-maps/marker-clusterer';
import { Box } from '@mui/material';

import { useAsset } from '@ocx-app/modules/configuration/use-asset.hook';
import { Paper, Typography } from '@ocx/ui';
import { Coordinates } from '@ocx-app/modules/stores/types';

export type StoreMarkerProp = {
  id: string;
  position: Coordinates;
  price: string | null;
  clusterer?: Clusterer;
  isInCluster: boolean;
  handleSelectStore(): void;
};

export const StoreMarker: React.FC<StoreMarkerProp> = (props) => {
  const { id, position, price, clusterer, isInCluster, handleSelectStore } = props;

  const mapMarkerSrc = useAsset('MapMarker');

  return (
    <>
      <Marker
        options={{
          icon: mapMarkerSrc,
        }}
        title={id}
        noClustererRedraw={false}
        onClick={handleSelectStore}
        position={position}
        clusterer={clusterer}
      />
      {!isInCluster && price !== null && (
        <OverlayView mapPaneName={OverlayView.FLOAT_PANE} position={position}>
          <Box width={0} height={0} display="flex" justifyContent="center" overflow="visible">
            <Box>
              <Paper
                sx={{
                  borderRadius: 5,
                  opacity: 0.7,
                  padding: '2px 6px',
                }}
                elevation={4}>
                <Typography variant="subtitle1">{price}</Typography>
              </Paper>
            </Box>
          </Box>
        </OverlayView>
      )}
    </>
  );
};
